import styled from 'styled-components'
interface TextProps {
  fontSize?: string
  fontColor?: string
  fontWeight?: string
}

interface GraphProps {
  height?: string
  $width?: string
}

interface DetailProps {
  gap?: string
}

interface DetailWrapperProps {
  $direction?: 'row' | 'column'
}

interface TextWrapperProps {
  $align?: 'flex-start' | 'center' | 'flex-end'
}

export const PageWrapper = styled.div`
  display: flex;
  width: 100%;
  gap: 32px;
  align-items: stretch;
  min-height: 0;
  height: 100%;
  overflow: visible;
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
  border-radius: 8px;
  box-shadow: 0px 4px 16px 0px #00000029;
  overflow: hidden;
`

export const BodyWrapper = styled.div`
  flex: 1;
  min-height: 0;
  padding: 24px;
  background: #ffffff;
  overflow-y: auto;
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  z-index: 1;
`

export const Body = styled.div`
  display: flex;
  gap: 40px;
  padding-bottom: 24px;
  width: 100%;
`

export const Left = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 50%;
`

export const Right = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 50%;
`

export const DetailFrame = styled.div<DetailProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${(props) => (props.gap ? props.gap : '16px')};
  align-self: stretch;
`

export const DetailLabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const DetailDescriptionText = styled.div`
  padding-left: 10px;
  color: var(--gray70, #808080);
  font-family: SUIT;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`

export const PvCustomerSummaryBox = styled.div`
  display: flex;
  width: 100%;
  padding: 12px;
  align-items: stretch;
  gap: 12px;
  align-self: stretch;
  flex-wrap: wrap;
  border-radius: 4px;
  border: 1px solid var(--gray30, #e6e6e6);
  background: var(--bluegray10, #f4f5f8);
`

export const PvCustomerSummaryItem = styled.div`
  display: flex;
  min-width: 130px;
  flex: 1 1 130px;
  flex-direction: column;
  gap: 4px;
`

export const PvCustomerSummaryLabel = styled.div`
  color: var(--gray70, #808080);
  font-family: SUIT;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`

export const PvCustomerSummaryValue = styled.div`
  color: var(--bluegray50, #2f3c5e);
  font-family: SUIT;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`

export const DetailWrapper = styled.div<DetailWrapperProps>`
  display: flex;
  width: 100%;
  flex-direction: ${(props) => props.$direction || 'row'};
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`
export const DetailColWrapper = styled.div`
  display: flex;
  width: 100%;
  padding-left: 10px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`

export const OptionListWrapper = styled.div`
  display: flex;
  align-content: flex-end;
  gap: 16px;
  align-self: stretch;
  flex-wrap: wrap;
`

export const PatternSelectWrapper = styled.div`
  display: flex;
  width: fit-content;
  max-width: 100%;
  padding: 12px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  border-radius: 4px;
  border: 1px solid var(--gray30, #e6e6e6);
  background: var(--gray10, #fff);
`

export const Line = styled.div`
  width: 100%;
  height: 1px;
  background: var(--gray50, #b3b3b3);
`

export const TextWrapper = styled.div<TextWrapperProps>`
  display: flex;
  flex-direction: column;
  align-items: ${(props) => props.$align || 'flex-start'};
  gap: 4px;
`
export const TextBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
`
export const TextBox2 = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  padding-top: 1px;
`

export const Text = styled.div<TextProps>`
  color: ${(props) => (props.fontColor ? props.fontColor : '#808080')};
  font-family: SUIT;
  font-size: ${(props) => (props.fontSize ? props.fontSize : '12px')};
  font-style: normal;
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : '600')};
  line-height: normal;
`

export const InputItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const InputLabel = styled.div`
  font-family: SUIT;
  font-size: 14px;
  font-weight: 600;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
  color: #2f3c5e;
`

export const GraphWrapper = styled.div<GraphProps>`
  display: flex;
  width: ${(props) => props.$width || '421px'};
  height: ${(props) => (props.height ? props.height : '')};
  padding: 12px;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  flex: 1 0 0;
  border-radius: 4px;
  border: 1px solid var(--gray30, #e6e6e6);
  background: var(--gray10, #fff);
`

export const GraphBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 8px;
  flex: 1 0 0;
  align-self: stretch;
`
export const SeasonFrame = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`
export const SeasonBox = styled.div`
  display: flex;
  padding: 6px 10px;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 2px;
  flex: 1 0 0;
  border-radius: 4px;
  background: var(--bluegray10, #f4f5f8);
`
export const SeasonTextBox = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`

export const Table = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  border-radius: 4px;
  border: 1px solid transparent;
  border-collapse: collapse;
`

export const TableRow = styled.div`
  display: flex;
`

export const GraphFrame = styled.div`
  padding: 0px 0px 0px 10px;
`

export const LabelTable = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const TableWrapper = styled.div`
  padding: 0px 0px 0px 10px;
`

interface TableGrayProps {
  white?: boolean
}

export const OptionDetailWrapper = styled.div`
  display: flex;
  padding: 12px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  border-radius: 4px;
  border: 1px solid var(--gray30, #e6e6e6);
  background: var(--gray10, #fff);
`

export const OptionDetailBox = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  gap: 4px;
`
export const Rectangle = styled.div`
  width: 4px;
  height: 14px;
  border-radius: 99px;
  background: var(--green100, #57c9a7);
`
export const OptionTextBox = styled.div`
  padding-top: 1px;
  width: max-content;
  color: var(--bluegray50, #2f3c5e);
  font-family: SUIT;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
`

interface TableGrayProps {
  white?: boolean
}

export const TableCell = styled.div<TableGrayProps>`
  display: flex;
  width: 100%;
  height: 59px;
  padding: 8px 0px 8px 0px;
  border: 0.5px solid #e6e6e6;
  background: ${(props) => (props.white ? '' : '#f4f5f8')};

  font-family: SUIT;
  font-size: 12px;
  font-weight: 500;
  line-height: 15px;
  letter-spacing: 0em;
  align-items: center;
  justify-content: center;
`
export const TableCell2 = styled.div<TableGrayProps>`
  display: flex;
  width: 100%;
  height: 50px;
  padding: 8px 0px 8px 0px;
  border: 0.5px solid #e6e6e6;
  background: ${(props) => (props.white ? '' : '#f4f5f8')};

  font-family: SUIT;
  font-size: 12px;
  font-weight: 500;
  line-height: 15px;
  letter-spacing: 0em;
  align-items: center;
  justify-content: center;
`

export const LastTableWrapper = styled.div`
  display: flex;
  width: max-content;
  height: 116px;
  flex-direction: column;
  align-items: center;
  flex: 1 0 0;
  background: var(--gray10, #fff);
`

export const TargetRevenueCard = styled.div`
  display: flex;
  width: 100%;
  max-width: 640px;
  padding: 14px;
  flex-direction: column;
  gap: 14px;
  border-radius: 4px;
  border: 1px solid var(--gray30, #e6e6e6);
  background: var(--gray10, #fff);
`

export const TargetRevenueSummary = styled.div`
  display: flex;
  padding: 12px;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  border-radius: 4px;
  background: var(--bluegray10, #f4f5f8);
`

export const TargetRevenueSummaryLabel = styled.div`
  color: var(--bluegray50, #2f3c5e);
  font-family: SUIT;
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`

export const TargetRevenueSummaryValue = styled.div`
  color: var(--bluegray50, #2f3c5e);
  font-family: SUIT;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  white-space: nowrap;
`

export const TargetRevenueFieldGrid = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
`

export const TargetRevenueField = styled.div`
  display: flex;
  min-width: 0;
  padding: 12px;
  flex-direction: column;
  gap: 8px;
  border-radius: 4px;
  border: 1px solid var(--gray30, #e6e6e6);
  background: var(--bluegray10, #f4f5f8);
`

export const TargetRevenueFieldLabel = styled.div<{ $minHeight?: string }>`
  min-height: ${({ $minHeight }) => $minHeight || 'auto'};
  color: var(--bluegray50, #2f3c5e);
  font-family: SUIT;
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`

export const TargetRevenueInputRow = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 8px;
`

export const TargetRevenueInputBox = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  height: 38px;
  overflow: hidden;
  border-radius: 4px;
  border: 1px solid #cfe8ff;
  background: #ffffff;
`

export const TargetRevenueUnit = styled.div`
  min-width: fit-content;
  color: var(--gray70, #808080);
  font-family: SUIT;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`

export const TargetRevenueFieldHelp = styled.div`
  color: var(--gray70, #808080);
  font-family: SUIT;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`

export const TargetRevenueDeltaPreview = styled.div<{
  $tone: 'positive' | 'negative' | 'neutral'
}>`
  color: ${({ $tone }) =>
    $tone === 'positive'
      ? 'var(--green100, #57c9a7)'
      : $tone === 'negative'
        ? '#d96c6c'
        : 'var(--gray70, #808080)'};
  font-family: SUIT;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`

export const TargetRevenueResult = styled.div`
  display: flex;
  padding: 12px;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  border-radius: 4px;
  border: 1px solid rgba(87, 201, 167, 0.35);
  background: rgba(87, 201, 167, 0.08);
`

export const TargetRevenueResultLabel = styled.div`
  color: var(--bluegray50, #2f3c5e);
  font-family: SUIT;
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`

export const TargetRevenueResultValue = styled.div`
  color: var(--bluegray50, #2f3c5e);
  font-family: SUIT;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  white-space: nowrap;
`

export const TargetRevenueToggleButton = styled.button`
  display: flex;
  width: fit-content;
  height: 32px;
  padding: 0 12px;
  align-items: center;
  justify-content: center;
  align-self: flex-start;
  border-radius: 4px;
  border: 1px solid var(--gray30, #e6e6e6);
  background: var(--gray10, #fff);
  color: var(--bluegray50, #2f3c5e);
  font-family: SUIT;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  cursor: pointer;

  &:hover {
    background: var(--bluegray10, #f4f5f8);
  }
`

export const TargetSeasonGrid = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
`

export const TargetSeasonCard = styled.div`
  display: flex;
  min-width: 0;
  padding: 12px;
  flex-direction: column;
  gap: 10px;
  border-radius: 4px;
  border: 1px solid var(--gray30, #e6e6e6);
  background: var(--bluegray10, #f4f5f8);
`

export const TargetSeasonHeader = styled.div`
  display: flex;
  width: fit-content;
  min-width: 40px;
  height: 24px;
  padding: 0 10px;
  align-items: center;
  justify-content: center;
  border-radius: 99px;
  border: 1px solid rgba(87, 201, 167, 0.35);
  background: rgba(87, 201, 167, 0.12);
  color: var(--bluegray50, #2f3c5e);
  font-family: SUIT;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`

export const TargetSeasonMetric = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`

export const TargetSeasonMetricLabel = styled.div`
  color: var(--gray70, #808080);
  font-family: SUIT;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`

export const TargetSeasonMetricValue = styled.div`
  color: var(--bluegray50, #2f3c5e);
  font-family: SUIT;
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-align: right;
  white-space: nowrap;
`

export const Input = styled.input`
  border: none;
  width: 50px;
  text-align: center;
  font-family: SUIT;
  font-size: 12px;
  font-weight: 500;
  line-height: 15px;
  letter-spacing: 0em;
  align-items: center;
  justify-content: center;
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`

export const MonthChipWrapper = styled.div`
  display: flex;
  gap: 4px;
  justify-content: center;
`

export const MonthChip = styled.div<{ selected: boolean }>`
  display: flex;
  min-width: 32px;
  height: 18px;
  padding: 0 6px;
  border-radius: 99px;
  background: #57c9a7;
  border: 1px solid #0000001a;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: ${({ selected }) =>
    selected ? 'rgba(87, 201, 167, 1)' : 'rgba(87, 201, 167, 0.1)'};
`

export const MonthChipText = styled.div`
  font-family: SUIT;
  font-size: 12px;
  font-weight: 500;
  text-align: left;
  color: #ffffff;
  color: #333333;
  user-select: none;
  white-space: nowrap;
`
